// extracted by mini-css-extract-plugin
export default {"page":"DMnrmhNlf3M9tQLinADe","divider":"pwkqBYeanRNVZ9rSVmvb","toolbar":"PAmMSiAc8aKnmPHRVNjZ"};